// import React from 'react'
// import UploadImage from '../components/UploadImage'
// import { useEffect, useState } from "react";
// import API from "../api";

// function UploadArticlse() {
//   const [title, setTitle] = useState("");
//   const [content, setContent] = useState("");
//   const [category, setCategory] = useState("movies");
//   const [subcategory, setSubcategory] = useState("regional");
//   const [imageUrl, setImageUrl] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const res = await API.post("/articles", {
//         title,
//         content,
//         category,
//         subcategory,
//         imageUrl,
//       });
//       alert("✅ Article posted successfully!");
//       setTitle("");
//       setContent("");
//       setImageUrl("");
//     } catch (err) {
//       console.error(err);
//       alert("❌ Failed to post article");
//     }
//   };

//   return (
//     <div className="container mt-5">
//       <h2 className="text-center mb-4">Post a New Article</h2>

//       <form onSubmit={handleSubmit} className="p-4 shadow rounded bg-light">
//         {/* Title */}
//         <div className="mb-3">
//           <label className="form-label">Title</label>
//           <input
//             type="text"
//             className="form-control"
//             value={title}
//             onChange={(e) => setTitle(e.target.value)}
//             required
//           />
//         </div>

//         {/* Content */}
//         <div className="mb-3">
//           <label className="form-label">Content</label>
//           <textarea
//             className="form-control"
//             rows="4"
//             value={content}
//             onChange={(e) => setContent(e.target.value)}
//             required
//           ></textarea>
//         </div>

//         {/* Category Dropdown */}
//         <div className="mb-3">
//           <label className="form-label">Category</label>
//           <select
//             className="form-select"
//             value={category}
//             onChange={(e) => setCategory(e.target.value)}
//           >
//             <option value="movies">Movies</option>
//             <option value="politics">Politics</option>
//           </select>
//         </div>

//         {/* Subcategory Dropdown */}
//         <div className="mb-3">
//           <label className="form-label">Subcategory</label>
//           <select
//             className="form-select"
//             value={subcategory}
//             onChange={(e) => setSubcategory(e.target.value)}
//           >
//             <option value="regional">Regional</option>
//             <option value="national">National</option>
//             <option value="international">International</option>
//           </select>
//         </div>

//         {/* Upload Image */}
//         <div className="mb-3">
//           <label className="form-label">Upload Image</label>
//           <UploadImage onUploadComplete={(url) => setImageUrl(url)} />
//           {imageUrl && (
//             <div className="mt-2">
//               <img
//                 src={imageUrl}
//                 alt="Preview"
//                 style={{
//                   width: "200px",
//                   borderRadius: "8px",
//                   boxShadow: "0 0 8px rgba(0,0,0,0.2)",
//                 }}
//               />
//             </div>
//           )}
//         </div>

//         <button type="submit" className="btn btn-primary w-100">
//           Submit Article
//         </button>
//       </form>
//     </div>
//   );
// }

// export default UploadArticlse
import React, { useState } from "react";
import UploadImage from "../components/UploadImage";
import API from "../api";
import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
import "quill/dist/quill.snow.css";



function UploadArticlse() {
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [category, setCategory] = useState("movies");
  const [subcategory, setSubcategory] = useState("regional");
  const [imagetype, setImagetype] = useState("desktop");
  const [type, setType] = useState("article");
  const [imageUrl, setImageUrl] = useState("");
  const [movie, setMovie] = useState("");
  const [releaseDate, setReleaseDate] = useState("");
  const [platform, setPlatform] = useState("");
  const [genre, setGenre] = useState("");
  const [theatricalReleaseDate, setTheatricalReleaseDate] = useState("");
  const [language, setLanguage] = useState("");

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };

  const formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post("https://movie-backend-1wmv.onrender.com/api/articles", {
        title,
        content,
        category,
        subcategory,
        type,
        imageUrl,
        imagetype,
        movie,
        releaseDate: formatDate(releaseDate),
        platform,
        genre,
        theatricalReleaseDate: formatDate(theatricalReleaseDate),
        language
      });
      alert("✅ Article posted successfully!");
      setTitle("");
      setContent("");
      setImageUrl("");
    } catch (err) {
      console.error(err);
      alert("❌ Failed to post article");
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Post a New Article</h2>

      <form onSubmit={handleSubmit} className="p-4 shadow rounded bg-light">
        <div className="mb-3">
          <label className="form-label fw-bold">Title</label>
          <input
            type="text"
            className="form-control"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>

        {/* <div className="mb-3">
          <label className="form-label fw-bold">Content</label>
          <textarea
            className="form-control"
            rows="4"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
          ></textarea>
        </div> */}
        <div className="mb-3">
          <label className="form-label fw-bold">Content</label>

          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            modules={modules}
            placeholder="Write your article here..."
            style={{ height: "250px", marginBottom: "40px" }}
          />
        </div>


        <div className="mb-3">
          <label className="form-label fw-bold">Category</label>
          <select
            className="form-select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value="movies">Movies</option>
            <option value="politics">Politics</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">Subcategory</label>
          <select
            className="form-select"
            value={subcategory}
            onChange={(e) => setSubcategory(e.target.value)}
          >
            <option value="regional">Regional</option>
            <option value="national">National</option>
            <option value="international">International</option>
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label fw-bold">ImageType</label>
          <select
            className="form-select"
            value={imagetype}
            onChange={(e) => setImagetype(e.target.value)}
          >
            <option value="mobile">Mobile view</option>
            <option value="desktop">Desktop view</option>
          </select>
        </div>

        {/* ✅ New Type Dropdown */}
        <div className="mb-3">
          <label className="form-label fw-bold">Type</label>
          <select
            className="form-select"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <option value="article">Article</option>
            <option value="review">Review</option>
            <option value="collection">Collection</option>
            <option value="header">Header</option>
            <option value="ott">OTT Release</option>
          </select>
        </div>
        {type === "ott" && (
          <>
            <div className="mb-3">
              <label className="form-label fw-bold">Movie</label>
              <input
                type="text"
                className="form-control"
                value={movie}
                onChange={(e) => setMovie(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">OTT Release Date</label>
              <input
                type="date"
                className="form-control"
                value={releaseDate}
                onChange={(e) => setReleaseDate(e.target.value)}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label fw-bold">Platform</label>
              <input
                type="text"
                className="form-control"
                placeholder="Netflix, Prime, Hotstar..."
                value={platform}
                onChange={(e) => setPlatform(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Genre</label>
              <input
                type="text"
                className="form-control"
                placeholder="Action, Drama, Thriller..."
                value={genre}
                onChange={(e) => setGenre(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Theatrical Release Date</label>
              <input
                type="date"
                className="form-control"
                value={theatricalReleaseDate}
                onChange={(e) => setTheatricalReleaseDate(e.target.value)}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Language</label>
              <input
                type="text"
                className="form-control"
                placeholder="Hindi, Telugu, Tamil..."
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                required
              />
            </div>
          </>
        )}


        {/* Upload Image */}
        <div className="mb-3">
          <label className="form-label fw-bold">Upload Image</label>
          <UploadImage onUploadComplete={(url) => setImageUrl(url)} />
          {/* <UploadImage
            onUploadComplete={(url) => {
              if (imagetype === "mobile") {
                setMobileImageUrl(url);
              } else {
                setImageUrl(url);
              }
            }}
          /> */}
          {imageUrl && (
            <img
              src={imageUrl}
              alt="Preview"
              style={{
                width: "200px",
                marginTop: "10px",
                borderRadius: "8px",
                boxShadow: "0 0 8px rgba(0,0,0,0.2)",
              }}
            />
          )}
        </div>

        <button type="submit" className="btn btn-primary w-100">
          Submit Article
        </button>
      </form>
    </div>
  );
}

export default UploadArticlse;
